export default "__VITE_ASSET__D$$NMu91__"